import React, { Component } from 'react';
import { fonts, colors, metrics } from '../../../styles';

//page title
import Typography from '@material-ui/core/Typography';

//table
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';

//title
import Title from '../../../components/Title';

//efect
import Fade from '@material-ui/core/Fade';

//loading
import { CircularProgress, Select, MenuItem} from '@material-ui/core';

//grid
import Grid from '@material-ui/core/Grid';

import { connect } from 'react-redux';

//modal
import Modal from './Modal.js';

//Service
import AircraftsModelsService from '../../../tools/AircraftsModelsService';

import { msgSimple, msgAction } from '../../../actions/snackbarActions';

//Icons
import { Cancel, CheckCircle, Search } from '@material-ui/icons';

import {
    List,
    ListItem,
    InputBase

} from '@material-ui/core';

import { fade } from '@material-ui/core/styles/colorManipulator';
import FooterTable from '../../../components/FooterTable';

//SweetAlert
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

class AircraftModel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            loading: true,
            loadingList: false,
            widthInput: 5,
            openModal: false,
            modal: {},
            data: '',
            listLength: 0,
            rowsPerPage: 10,
            page: 0,
            models: [],
            search: '',
            actives: 1
        }

    }

    componentWillMount() {
        this.setState({ loading: true })
        this.handleRefreshState();
    }

    handleSearch = (text) => {
        AircraftsModelsService.get(1, this.state.rowsPerPage, this.state.actives, this.state.search).then(result => {
            this.setState({ loading: false })
            if (result.ok) {
                this.setState({
                    page: 0,
                    search: text,
                    pageLength: result.response.docs.length,
                    listLength: result.response.total,
                    models: result.response.docs
                })
            }
        })
    }

    handleRefreshState = () => {
        this.setState({ loading: true })
        AircraftsModelsService.get(1, this.state.rowsPerPage, this.state.actives).then(result => {
            this.setState({ loading: false })
            if (result.ok) {
                this.setState({
                    page: 0,
                    pageLength: result.response.docs.length,
                    models: result.response.docs,
                    listLength: result.response.total,
                })
            }
        })
    }

    handleSave = item => {
        Swal.fire({
            title: '<strong>Deseja realmente salvar as alterações realizadas?</strong>',
            type: 'info',
            // html:'',
            customClass: '{ z-index: 1000000 }',
            customContainerClass: '{ z-index: 100000 }',
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText:
                '<i class="fa fa-thumbs-up"></i> Salvar',
            confirmButtonAriaLabel: 'Salvar',
            cancelButtonText:
                '<i class="fa fa-thumbs-down"></i> Cancelar',
            cancelButtonAriaLabel: 'Cancelar',
        }).then((result) => {
            if (!!result.value) {
                if (item.id === 'new') {
                    let { models } = this.state;
                    models.push({ ...item })
                    models.reverse()
                    this.setState({ models })
                    delete item.id
                    AircraftsModelsService.create(item).then(result => {
                        if (result.ok) {
                            this.handleRefreshState();
                            this.props.msgSimple(item.icao_model + ' criado com sucesso.')
                        } else {
                            let { models } = this.state;
                            models = models.filter(e => e.id !== 'new')
                            models.reverse()
                            this.setState({ models })
                            this.props.msgAction('Erro ao criar "' + item.icao_model + '"', 'TENTAR NOVAMENTE', () => this.handleSave(item))
                        }
                    })

                } else {
                    let { models } = this.state;
                    models = models.filter(e => e.id !== item.id)
                    models.push({ ...item, id: 'new' })
                    models.reverse()
                    this.setState({ models })
                    AircraftsModelsService.update(item.id, item).then(result => {
                        if (result.ok) {
                            this.handleRefreshState();
                            this.props.msgSimple(item.icao_model + ' atualizado com sucesso.')
                        } else {
                            let { models } = this.state;
                            models = models.filter(e => e.id !== 'new')
                            models.reverse()
                            this.setState({ models })
                            this.props.msgAction('Erro ao atualizar "' + item.icao_model + '"', 'TENTAR NOVAMENTE', () => this.handleSave(item))
                        }
                    })
                }
                this.setState({ openModal: false });
            } else
                return MySwal.fire({ title: '<p>Operação cancelada!</p>', type: 'error' })
        })
    }

    handleClickOpen = (item) => {
        this.setState({ modal: item });
        this.setState({ openModal: !this.state.openModal });
    };

    handleOnClose = () => {
        AircraftsModelsService.get(1, 10).then(result => {
            this.setState({ loading: false })
            if (result.ok) {
                this.setState({ models: result.response.docs, pageLength: result.response.docs.length, page: 0 });
            }
        })
    }

    handleClose = () => {
        Swal.fire({
            title: '<strong>Deseja sair sem salvar as alterações realizadas?</strong>',
            type: 'info',
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText:
                '<i class="fa fa-thumbs-up"></i> Sim',
            confirmButtonAriaLabel: 'Sim',
            cancelButtonText:
                '<i class="fa fa-thumbs-down"></i> Não',
            cancelButtonAriaLabel: 'Não',
        }).then((result) => {
            if (!!result.value) {
                this.setState({ openModal: !this.state.openModal });
            }
        });
    };

    handleChangeRowsPerPage = (rows) => {
        this.setState({ rowsPerPage: rows })
        this.setState({ loadingList: true })
        AircraftsModelsService.get( 1, rows,this.state.actives, this.state.search).then(result => {
            this.setState({ loadingList: false })
            if (result.ok) {
                this.setState({
                    page: 0,
                    pageLength: result.response.docs.length,
                    listLength: result.response.total,
                    models: result.response.docs
                })
            }
        })
    }

    handleChangePage = (page) => {
        AircraftsModelsService.get( page + 1, this.state.rowsPerPage, this.state.actives, this.state.search).then(result => {
            if (result.ok) {
                this.setState({
                    page,
                    pageLength: result.response.docs.length,
                    listLength: result.response.total,
                    models: result.response.docs
                })
            }
        })
    };


    render() {
        return (
            <Fade in={true}>
                <Grid item container xs={12} sm={12} md={12} lg={12} xl={12} style={{ overflow: 'auto' }} >
                    <Modal modal={this.state.modal} openModal={this.state.openModal} func={this.handleClose} handleSave={this.handleSave} />
                    <Grid item style={{ borderBottomWidth: 'solid' }} container xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Title title={'Modelo de Aeronaves'} subTitle={'Configurações'} function={() => this.handleClickOpen({ id: 'new' })} AddButton={'Adicionar Modelo de Aeronave'} />
                        <Divider style={styles.divider} />
                    </Grid>
                    <Grid item style={styles.page} container justify='center' >
                        {/* {this.state.models.length > 0 && */}
                        <Paper style={styles.paper} >
                            <List
                                style={{ width: '100%', backgroundColor: colors.white }}
                                subheader={
                                    <ListItem key={1} style={{ backgroundColor: colors.primary_darker, color: colors.white }}>
                                        <Grid container>
                                            <Grid container alignItems='center' item md={1} sm={3} xs={5} >
                                                <Select
                                                    value={this.state.actives}
                                                    onChange={ async event=>{
                                                        await this.setState({
                                                            actives:event.target.value
                                                        })
                                                        await this.handleRefreshState();
                                                    }}
                                                    style={{color:'white'}}
                                                    displayEmpty
                                                >
                                                    <MenuItem value={null}>Todos</MenuItem>
                                                    <MenuItem value={1}>Ativos</MenuItem>
                                                    <MenuItem value={0}>Inativos</MenuItem>
                                                </Select>
                                            </Grid>
                                            <Grid container alignItems='center' item md={3} sm={8} xs={6} >Fabricante</Grid>
                                            <Grid container alignItems='center' item md={2} sm={8} xs={6} >TCDS</Grid>
                                            <Grid container alignItems='center' item md={3} sm={8} xs={6} >ICAO</Grid>
                                            <Grid container alignItems='center' justify='flex-end' item md={3} sm={1} xs={1} >
                                                <Grid container alignItems='center' item md={this.state.widthInput} style={{ transition: 'all .5s ease', backgroundColor: fade(colors.primary, 0.15), borderRadius: 6, padding: 2, color: colors.white }}>
                                                    {/* <Grid item md={2}>
                                                            <Search />
                                                        </Grid> */}
                                                    <Grid item md={12} style={{ padding: 2, color: colors.white }}>
                                                        <Fade in={true} style={{ transitionDelay: 500 }}>
                                                            <InputBase
                                                                autoFocus={false}
                                                                onKeyDown={event => {
                                                                    if (event.key === 'Enter')
                                                                        this.handleSearch(this.state.search)
                                                                }}
                                                                onFocus={() => this.setState({ widthInput: 12 })}
                                                                onBlur={() => this.setState({ widthInput: 5 })}
                                                                placeholder="Pesquisar"
                                                                onChange={event => {
                                                                    this.setState({ search: event.target.value })
                                                                }}
                                                                style={{ width: '100%', color: colors.white }}
                                                                startAdornment={(<Search style={{ paddingRight: 5 }} />)}
                                                            />
                                                        </Fade>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                        </Grid>
                                    </ListItem>
                                }
                            >
                                {this.state.models.map((element, index) => (
                                    <div>
                                        <ListItem key={element.id} dense button onClick={() => this.handleClickOpen(element)}>
                                            <Grid container>
                                                <Grid item md={1} sm={3} xs={5}>{element.active ? <CheckCircle style={{ color: colors.success }} /> : <Cancel style={{ color: colors.danger }} />}</Grid>
                                                <Grid container alignItems='center' item md={3} sm={7} xs={5} >{element.aircraft_manufacturer && element.aircraft_manufacturer.manufacturer}</Grid>
                                                <Grid container alignItems='center' item md={2} sm={7} xs={5} >{element.tcds_model}</Grid>
                                                <Grid container alignItems='center' item md={3} sm={7} xs={5} >{element.icao_model}</Grid>
                                                <Grid container alignItems='center' item md={3} sm={2} xs={2} justify='flex-end'>
                                                    {
                                                        (element.id === 'new') && (
                                                            <Grid item>
                                                                {element.id === 'new' ? <CircularProgress size={20} /> : 'error'}
                                                            </Grid>
                                                        )
                                                    }
                                                </Grid>
                                            </Grid>
                                        </ListItem>
                                        <Divider />
                                    </div>
                                ))}
                            </List>
                            {
                                this.state.loading &&
                                <Grid container direction='row' justify='center'>
                                    <CircularProgress size={60} />
                                </Grid>
                            }
                            {
                                !this.state.loading && this.state.models.length === 0 &&
                                <Grid container justify='center' >
                                    <Typography>Não há modelo de aeronave cadastrado</Typography>
                                </Grid>
                            }
                            <FooterTable
                                pageLength={this.state.pageLength}
                                count={this.state.listLength}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                labelRowsPerPage={'Itens por página'}
                            />
                        </Paper>
                        {/* } */}

                    </Grid>
                </Grid>
            </Fade>

        );
    }
}

const styles = {
    modal: {
        position: 'absolute',
        top: '20%',
        left: '26%',
        height: '50%',
        width: '50%',

    },
    page: {
        padding: metrics.paddingPage,
    },
    menuLeft: {
        backgroundColor: 'red',
    },
    screen: {
        flex: 1,
        position: 'relative',
        overflow: 'hidden',
        marginBottom: 30
    },
    paper: {
        flex: 1
    },
    top: {
        padding: 20,
        backgroundColor: 'white'
    },
    divider: {
        marginBottom: 15,
        width: '100%'
    },
    root: {
        flex: 1,
        marginLeft: 75,
        marginRight: 75,
        elevation: 4

    },
    header: {
        // background: '#f5f5f5',
        // color: 'black',
        height: 60
    },
    headerText: {
        fontSize: fonts.tableHeader
    },
    bodyText: {
        fontSize: fonts.tableBody
    },
    table: {
        height: '80%',
        maxHeight: '100%',
        marginBottom: 20
    },
    floatButton: {
        float: 'right',
        postion: 'absolute',
        // bottom: 0.09 * window.innerHeight,
        // left: 0.95 * window.innerWidth


    }
}


const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {
    msgSimple,
    msgAction
};

export default connect(mapStateToProps, mapDispatchToProps)(AircraftModel)


// WEBPACK FOOTER //
// ./src/routes/settings/aircraft-model/index.js